<script setup lang="ts">
defineOptions({
  name: 'DataTableColumn',
});
defineProps({
  field: {
    type: String,
    default: '',
    required: true,
  },
});
</script>
<template>
  <slot name="header"></slot>
  <slot name="body" value="" data=""></slot>
  <slot name="footer"></slot>
</template>
